import React from "react";
import { Container, Grid, Card, Box, Typography, Stack } from "@mui/material";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import ScienceIcon from "@mui/icons-material/Science";
import ArticleIcon from "@mui/icons-material/Article";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SectionHeading from "./SectionHeading";
import { colors, fonts, ui } from "../theme";

const serviceBlocks = [
  {
    icon: <IntegrationInstructionsIcon />,
    title: "Project Development",
    items: [
      "End-to-End UG & PG Projects",
      "IEEE Projects",
      "AI & Machine Learning Projects",
      "Data Science Projects",
      "Full Stack (MERN) & Java Projects",
      "Mobile App (Flutter) Development",
      "IoT & Embedded Projects",
    ],
  },
  {
    icon: <ScienceIcon />,
    title: "Research Support",
    items: [
      "Research Methodology Guidance",
      "Literature Review Assistance",
      "Technical Mentoring",
      "Paper Drafting Support",
      "Project Documentation",
    ],
  },
  {
    icon: <ArticleIcon />,
    title: "Publication Support",
    items: [
      "Journal Publication Support",
      "Scopus Indexed Publication Assistance",
      "Publication Guidance & Consultation",
      "Review & Quality Enhancement",
      "PPT & Viva Preparation",
    ],
  },
];

const trustPoints = [
  "Expert Mentors",
  "Research-Focused Approach",
  "Industry-Oriented Projects",
  "Personalized Guidance",
  "Timely Delivery",
  "Continuous Technical Support",
];

const ProjectServices = () => {
  return (
    <section id="projects-section" className="projects-section">
      <Box sx={{ py: { xs: 5, md: 7 } }}>
        <Container>
          <SectionHeading
            eyebrow="Final Year Projects, Research & Publication"
            title="End-to-End Projects, Research & Scopus Publication Support"
            subtitle="Industry-aligned academic solutions for UG, PG & Research Scholars — from project topic to production build, paper drafting and Scopus-indexed publication."
          />

          <Grid container spacing={3}>
            {serviceBlocks.map((b) => (
              <Grid item xs={12} sm={6} md={4} key={b.title}>
                <Card
                  elevation={0}
                  sx={{
                    ...ui.cardHover,
                    height: "100%",
                    p: 3,
                    borderRadius: 3,
                    border: "1px solid #e6edf7",
                    bgcolor: colors.white,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box
                    sx={{
                      width: 50,
                      height: 50,
                      borderRadius: 2,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: colors.blueTint,
                      color: colors.blueDark,
                      border: "1px solid rgba(56,182,255,0.22)",
                      mb: 2,
                    }}
                  >
                    {b.icon}
                  </Box>
                  <Typography
                    sx={{ fontFamily: fonts.heading, fontWeight: 700, color: colors.navy, mb: 1.75, fontSize: "1.1rem" }}
                  >
                    {b.title}
                  </Typography>
                  <Stack spacing={1.1}>
                    {b.items.map((it) => (
                      <Stack direction="row" spacing={1} key={it} alignItems="flex-start">
                        <CheckCircleIcon sx={{ fontSize: 18, color: colors.blue, mt: "1px" }} />
                        <Typography sx={{ color: colors.textBody, fontSize: "0.9rem", lineHeight: 1.5 }}>
                          {it}
                        </Typography>
                      </Stack>
                    ))}
                  </Stack>
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* Trust band */}
          <Box
            sx={{
              mt: 4,
              p: { xs: 3, md: 3.5 },
              borderRadius: 3,
              background: colors.navy,
            }}
          >
            <Typography
              sx={{ color: colors.blue, fontWeight: 700, fontSize: "0.78rem", letterSpacing: "0.1em", mb: 2, textTransform: "uppercase" }}
            >
              Why Students & Departments Trust Crescent EdTech
            </Typography>
            <Grid container spacing={1.5}>
              {trustPoints.map((t) => (
                <Grid item xs={12} sm={6} md={4} key={t}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <CheckCircleIcon sx={{ fontSize: 18, color: colors.blue }} />
                    <Typography sx={{ color: "rgba(255,255,255,0.9)", fontSize: "0.92rem", fontWeight: 500 }}>
                      {t}
                    </Typography>
                  </Stack>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Container>
      </Box>
    </section>
  );
};

export default ProjectServices;
